import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import logo from '../assets/images/Logo.png';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const containerStyle = {
	fontSize: '19px',
	fontFamily: 'Calibri, sans-serif',
};

const pricingListStyle = {
	listStyleType: 'decimal',
	marginLeft: '0.5in',
};

const nestedListStyle = {
	listStyleType: 'upper-alpha',
	marginLeft: '1em',
};

const subNestedListStyle = {
	listStyleType: 'lower-roman',
	marginLeft: '2em',
};

export default function ClinetPlans() {
	const [getPlan, setGetPlan] = useState(null);
	const [selectedPlanId, setSelectedPlanId] = useState(null);
	const navigate = useNavigate();
	const fetchData = async () => {
		try {
			const response = await axios.get(
				'https://api.getcogen.com/api/getClientPlans',
				{
					headers: { Accept: 'application/json' },
				}
			);
			setGetPlan(response?.data?.client_plans);
			console.log('Data retrieved successfully:', response?.data?.plans);
		} catch (error) {
			toast.error(error.response?.data?.message);
			console.error('Error fetching data:', error.message);
		}
	};

	const handlePlanUpdate = async () => {
		try {
			const accessToken = JSON.parse(localStorage.getItem('cogen_user_profile'))?.accessToken;
			const planId = parseInt(selectedPlanId);
			const response = await axios.post('https://api.getcogen.com/api/user_update_plan',
				{ plan_id: planId },
				{
					headers: {
						Accept: 'application/json',
						Authorization: `Bearer ${accessToken}`,
					},
				}
			);
			if (response?.data?.success == true) {
				toast.success(response?.data?.message);
				navigate('/stripe');
				return;
			}
		} catch (error) {
			toast.error('Failed to update plan id');
			console.log(error);
		}
	};

	const logout = () => {
		const tokenId = localStorage.getItem('cogen_user_profile');

		axios.delete(
			'http://ec2-3-13-248-4.us-east-2.compute.amazonaws.com/dev/logout/' +
			tokenId
		);
		localStorage.clear();
		// localStorage.setItem('userType', 'public');
		window.location.href = `/`;
	};
	const handleHomeClick = () => {
		const tokenId = localStorage.getItem('cogen_user_profile');

		axios.delete(
			'http://ec2-3-13-248-4.us-east-2.compute.amazonaws.com/dev/logout/' +
			tokenId
		);
		localStorage.clear();
		// localStorage.setItem('userType', 'public');
		window.location.href = `/`;
	};
	useEffect(() => {
		fetchData();
	}, []);

	const Basic = getPlan?.[0]?.plan_name;
	const Premium = getPlan?.[1]?.plan_name;
	return (
		<Container>
			<Row className='d-flex py-5 mt-1 justify-content-center align-items-center'>
				<Col>
					<img
						src={logo}
						alt='logo'
						onClick={handleHomeClick}
						style={{
							height: '10vmin',
							marginLeft: '105px',
							marginBottom: '30px',
							cursor: 'pointer',
						}}
					/>
					<h1>Welcome to Cogen</h1>
					<p className='font-italic text-muted mb-0'>
						Choose between our {Basic} and {Premium} plans, each offering unique
						benefits. Find the perfect plan tailored to your needs and elevate
						your experience with Cogen.
					</p>
					<div style={containerStyle}>
						<ol style={pricingListStyle}>
							<ol style={nestedListStyle}>
								{getPlan?.map(plan => (
									<li>
										<div
											className='form-check'
											style={{ marginTop: '10px' }}
											key={plan.id}
										>
											<input
												className='form-check-input'
												type='radio'
												name='plan_id'
												id={`flexRadioDefault${plan.id}`}
												value={plan.id.toString()} // Convert the id to a string as it is used as the value
												onChange={e => setSelectedPlanId(e.target.value)}
												required
											/>
											<label
												className='form-check-label'
												style={{ fontWeight: 'bold' }}
											>
												{plan.plan_name} Program (${plan.mentanance_fee})
											</label>{' '}
											<br />
											{/* <label className='form-check-label font-italic text-muted mb-0'>
												Initial Startup Fee is ${plan.annual_fee}. This includes
												the Initial Setup Fee and 1 year Maintenance and Tech
												Support .
											</label> */}
											<label className='form-check-label font-italic text-muted mb-0'>
												The Maintenance and Tech Support Fee will be charged at {plan.mentanance_fee} USD.<br />
											</label>

											{plan.plan_name === 'Basic' && (
												<>
													<label className='form-check-label font-italic text-muted mb-0'>
														Up to 48-hour response by
													</label>
													<ol style={subNestedListStyle}>
														<ol style={{ listStyleType: 'decimal' }}>
															<li>Email submission</li>
															<li>Chat submission</li>
															<li>Website submission</li>
														</ol>
													</ol>
												</>
											)}
											{plan.plan_name === 'Premium' && (
												<>
													<label className='form-check-label font-italic text-muted mb-0'>
														Same Day up to Next Day Service
													</label>
													<ol style={subNestedListStyle}>
														<ol style={{ listStyleType: 'decimal' }}>
															<li>Telephone</li>
															<li>Chat</li>
														</ol>
													</ol>
												</>
											)}
										</div>
									</li>
								))}
							</ol>
						</ol>
					</div>
				</Col>
				<Col sm={10}>
					<Button
						onClick={handlePlanUpdate}
						sx={{ float: 'right', marginLeft: '12px' }}
						variant='contained'
					>
						Update
					</Button>
					<Button
						variant='contained'
						sx={{ float: 'right', background: 'red' }}
						onClick={() => logout()}
					>
						LOGOUT
					</Button>
				</Col>
			</Row>
		</Container>
	);
}
